import { PhoneInput } from "react-international-phone";
import { formatMoney } from "../../utils";
import TicketSvg from "../../assets/imgs/ticket.svg";
import {
  TicketType,
  TicketOwner,
  OtherInformationAnswer,
} from "../../utils/types";
import { useEffect, useMemo, useState } from "react";
import parse from "html-react-parser";

export function BuyTicketStepOne({
  ticketTypes,
  handleEditTicket,
}: {
  ticketTypes: TicketType[];
  handleEditTicket: (el: TicketType, action: string, quantity?: number) => void;
}) {
  const [
    selectedIndexes,
    // setSelectedIndexes
  ] = useState<number[] | null>(null);
  return (
    <div className='buy-ticket-container-left_ticket-container'>
      <h3>Select Tickets</h3>
      <div className='buy-ticket-container-left_ticket-container-types'>
        {!ticketTypes.length ? (
          <div className='no-ticket'>
            <img src={TicketSvg} alt='ticket-svg' className='img-fluid' />
            <h3>No tickets found for this event!</h3>
          </div>
        ) : null}
        {ticketTypes.map((ticket, key) => (
          <div
            className='buy-ticket-container-left_ticket-container-types-type'
            key={key}
          >
            <div className='price'>
              {ticket?.for && ticket.for > 1 ? (
                <span className='group-banner'>GROUP</span>
              ) : null}
              <p>{ticket.name}</p>
              <p className='amount'>
                {ticket.price > 0 ? `₦${formatMoney(ticket.price)}` : "Free"}
              </p>
              {ticket?.description ? (
                <>
                  <div className='d-inline-flex see-description'>
                    <p
                      className={`subtle-description-text ${
                        selectedIndexes?.includes(key) ? "full" : ""
                      }`}
                    >
                      {parse(ticket.description)}
                    </p>
                    {/* {ticket.description.length ? (
                      <button
                        className='see-description-button'
                        onClick={() => {
                          if (selectedIndexes?.includes(key))
                            return setSelectedIndexes(
                              selectedIndexes.filter((el) => el !== key)
                            );
                          setSelectedIndexes([...(selectedIndexes ?? []), key]);
                        }}
                      >
                        {selectedIndexes?.includes(key) ? "Hide" : "See more"}
                      </button>
                    ) : null} */}
                  </div>
                </>
              ) : null}
            </div>
            <div className={`counter ${ticket?.isClosed ? "closed" : ""}`}>
              <button
                onClick={() => handleEditTicket(ticket, "subtract")}
                disabled={ticket.quantity === 0 || ticket?.isClosed}
                className={
                  ticket.quantity === 0 || ticket?.isClosed
                    ? "disabled"
                    : "active"
                }
              >
                <i className='bi bi-dash'></i>
              </button>
              <input
                type='number'
                min={0}
                onChange={(e) => {
                  const inputValue = e.target.value.replace(/^0+(?!$)/, "");
                  handleEditTicket(ticket, "set", Number(inputValue));
                }}
                disabled={ticket?.isClosed}
                value={Number(ticket.quantity ?? 0).toString()}
              />
              <button
                onClick={() => handleEditTicket(ticket, "add")}
                disabled={ticket?.isClosed}
                className={ticket?.isClosed ? "disabled" : "active"}
              >
                <i className='bi bi-plus'></i>
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export function BuyTicketStepTwo({
  selectedTickets,
  setTicketOwners,
  ticketOwners,
  setPrimaryTicketOwner,
  primaryTicketOwner,
  totalValues,
}: {
  selectedTickets: TicketType[];
  setTicketOwners: (el: TicketOwner[]) => void;
  ticketOwners: TicketOwner[];
  setPrimaryTicketOwner: (el: TicketOwner | null) => void;
  primaryTicketOwner: TicketOwner | null;
  totalValues: { total: number; discount: number; totalQuantity: number };
}) {
  // const totalTicketsToBeBought = totalValues.totalQuantity;
  const totalTicketsToBeBought = ticketOwners.length;

  useEffect(() => {
    let ticketOwnersArr: TicketOwner[] = [];
    for (let i = 0; i < selectedTickets.length; i++) {
      const ticket = selectedTickets[i];
      const quantity = Number(ticket.quantity ?? 0) * Number(ticket.for ?? 1);
      const ticketsByType = Array.from({ length: quantity }, () => {
        const body = {
          firstName: "",
          lastName: "",
          email: "",
          phoneNumber: "",
          ticketType: ticket.name,
          ticketTypeId: ticket.id ?? "",
          ticketIndexNumber: i + 1,
        };
        return body;
      });
      ticketOwnersArr.push(...ticketsByType);
    }

    ticketOwnersArr.forEach((tO, index) => {
      const ticketOwner = ticketOwners[index];
      if (ticketOwner) {
        ticketOwnersArr[index] = {
          ...ticketOwner,
          ticketType: tO.ticketType,
          ticketIndexNumber: tO.ticketIndexNumber,
        };
      }
    });

    const primaryTicketOwnerIndex = ticketOwnersArr.findIndex(
      (ticketOwner) =>
        ticketOwner.ticketIndexNumber ===
          primaryTicketOwner?.ticketIndexNumber &&
        ticketOwner.ticketType === primaryTicketOwner?.ticketType
    );

    if (primaryTicketOwnerIndex < 0) {
      const remainingTicketOwners = ticketOwnersArr.filter(
        (ticketOwner) =>
          ticketOwner.ticketIndexNumber !==
            primaryTicketOwner?.ticketIndexNumber &&
          ticketOwner.ticketType !== primaryTicketOwner?.ticketType
      );
      setTicketOwners([...remainingTicketOwners]);
      if (remainingTicketOwners.length === 1) {
        setPrimaryTicketOwner(remainingTicketOwners[0]);
      } else {
        setPrimaryTicketOwner(null);
      }
    }
    setTicketOwners([...ticketOwnersArr]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleUserInput = (
    field: string,
    e: React.ChangeEvent<HTMLInputElement>,
    index: number,
    ticketType: string
  ) => {
    if (
      totalTicketsToBeBought === 1 ||
      (primaryTicketOwner?.ticketType === ticketType &&
        primaryTicketOwner?.ticketIndexNumber === index + 1)
    ) {
      setPrimaryTicketOwner({
        ...primaryTicketOwner!,
        [field]:
          field === "email"
            ? e.target.value.toLowerCase().trim()
            : e.target.value,
        ticketType,
        ticketIndexNumber: index + 1,
      });
    }
    const ticketOwnerIndex = index;
    const selectedTicketOwners = [...(ticketOwners ?? [])];
    if (ticketOwnerIndex < 0) return;
    selectedTicketOwners[ticketOwnerIndex] = {
      ...selectedTicketOwners[ticketOwnerIndex],
      [field]:
        field === "email"
          ? e.target.value.toLowerCase().trim()
          : e.target.value,
    };
    setTicketOwners([...selectedTicketOwners]);
  };

  const handleSetPrimaryTicket = (ticket: TicketType, index: number) => {
    if (
      primaryTicketOwner &&
      primaryTicketOwner.ticketIndexNumber === index + 1 &&
      primaryTicketOwner.ticketType === ticket.name
    )
      return setPrimaryTicketOwner(null);
    const ticketOwner = ticketOwners[index] ?? {
      firstName: "",
      lastName: "",
      email: "",
      phoneNumber: "",
    };
    setPrimaryTicketOwner({
      ...ticketOwner,
      ticketType: ticket.name,
      ticketTypeId: ticket.id!,
      ticketIndexNumber: index + 1,
    });
  };

  return (
    <div className='buy-ticket-container-left_contact-container'>
      <h3>Contact Information</h3>
      <form
        onSubmit={(e) => {
          e.preventDefault();
        }}
      >
        {ticketOwners.map((el, index) => {
          const ticket = selectedTickets.find(
            (ticket) => ticket.name === el.ticketType
          );
          return (
            <div
              className='buy-ticket-container-left_contact-container-form-container'
              key={index}
            >
              <h4>
                Ticket {index + 1} - {el.ticketType}
              </h4>
              <div className='buy-ticket-container-left_contact-container-form'>
                {totalTicketsToBeBought > 1 ? (
                  <div
                    className='sole-user-container'
                    onClick={() => {
                      handleSetPrimaryTicket(ticket!, index);
                    }}
                  >
                    <input
                      type='checkbox'
                      checked={
                        primaryTicketOwner?.ticketIndexNumber === index + 1
                      }
                      disabled={
                        Boolean(primaryTicketOwner) &&
                        primaryTicketOwner?.ticketIndexNumber !== index + 1
                      }
                    />{" "}
                    This is my ticket
                  </div>
                ) : null}
                <div className='row'>
                  <div className='col-md-6 col-12 form-group'>
                    <label>
                      First name <span>*</span>
                    </label>
                    <input
                      type='text'
                      placeholder='First Name'
                      onChange={(e) => {
                        handleUserInput("firstName", e, index, el.ticketType);
                      }}
                      value={el.firstName ?? ""}
                    />
                  </div>
                  <div className='col-md-6 col-12 form-group'>
                    <label>
                      Last name <span>*</span>
                    </label>
                    <input
                      type='text'
                      placeholder='Last Name'
                      onChange={(e) => {
                        handleUserInput("lastName", e, index, el.ticketType);
                      }}
                      value={el.lastName ?? ""}
                    />
                  </div>
                </div>
                <div className='row'>
                  <div className='col-md-6 col-12 form-group'>
                    <label>
                      Email address <span>*</span>
                    </label>
                    <input
                      type='text'
                      placeholder='Email address'
                      onChange={(e) => {
                        handleUserInput("email", e, index, el.ticketType);
                      }}
                      value={el.email ?? ""}
                    />
                  </div>
                  <div className='col-md-6 col-12 form-group'>
                    <label>
                      Phone Number <span>*</span>
                    </label>
                    <PhoneInput
                      defaultCountry='ng'
                      value={el.phoneNumber ?? ""}
                      onChange={(phone) => {
                        handleUserInput(
                          "phoneNumber",
                          {
                            target: {
                              value: phone,
                            },
                          } as React.ChangeEvent<HTMLInputElement>,
                          index,
                          el.ticketType
                        );
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </form>
    </div>
  );
}

export function BuyTicketStepThree({
  questions,
  setOtherInfoAnswers,
  otherInfoAnswers,
  ticketOwners,
  setTicketOwners,
}: {
  questions: { question: string; required: boolean }[];
  setOtherInfoAnswers: (val: OtherInformationAnswer[] | []) => void;
  otherInfoAnswers: OtherInformationAnswer[];
  ticketOwners: TicketOwner[];
  setTicketOwners: (el: TicketOwner[]) => void;
}) {
  const newUrlSearchParams = new URLSearchParams(window.location.search);
  const referee = newUrlSearchParams.get("referee");

  const handleAnsweringQuestions = ({
    question,
    required, // is answer required
    answer,
    index,
  }: OtherInformationAnswer) => {
    const ticketOwner = ticketOwners[index];
    const info = { ...ticketOwner?.info, [question]: answer };
    ticketOwners[index] = { ...ticketOwners[index], info };
    setTicketOwners([...ticketOwners]);
  };

  const hasReferralCodeOption = questions.some(
    (q) => q.question.toLowerCase() === "referral code"
  );

  const filteredQuestions = useMemo(() => {
    if (!hasReferralCodeOption) return questions;
    return questions.filter(
      (q) => q.question.toLowerCase() !== "referral code"
    );
  }, [hasReferralCodeOption, questions]);

  useEffect(() => {
    if (!referee) return;
    const ticketOwner = ticketOwners[0];
    const info = { ...ticketOwner?.info, "Referral Code": referee };
    ticketOwners[0] = { ...ticketOwners[0], info };
    setTicketOwners([...ticketOwners]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [referee]);

  return (
    <div className='buy-ticket-container-left_contact-container'>
      <h3>Other Information</h3>
      <form>
        {ticketOwners
          .reduce((acc: TicketOwner[], ticketOwner) => {
            // we do this because the only field that needs to be filled is the referral code and it's optional
            if (
              hasReferralCodeOption &&
              !acc.length &&
              !filteredQuestions.length
            )
              return [...acc, ticketOwner];
            return [...acc, ticketOwner];
          }, [] as TicketOwner[])
          .map((ticketOwner, index) => (
            <div
              className={`buy-ticket-container-left_contact-container-form-container ${
                hasReferralCodeOption && !filteredQuestions.length && index
                  ? "hide"
                  : ""
              }`}
              key={index}
            >
              <h4>
                Ticket {index + 1} - {ticketOwner.firstName}
              </h4>
              <div className='buy-ticket-container-left_contact-container-form'>
                <div className='row'>
                  {filteredQuestions.map((q, index2) => (
                    <div className='col-md-6 col-12 form-group' key={index2}>
                      <label>
                        {q.question} {q.required ? <span>*</span> : null}
                      </label>
                      <input
                        type='text'
                        value={ticketOwner.info?.[q.question] ?? ""}
                        onChange={({ target: { value } }) =>
                          handleAnsweringQuestions({
                            question: q.question,
                            required: q.required,
                            answer: value,
                            index,
                          })
                        }
                      />
                    </div>
                  ))}
                  {hasReferralCodeOption && !index ? (
                    <div className='col-md-6 col-12 form-group'>
                      <label>Referral Code</label>
                      <input
                        type='text'
                        disabled={Boolean(referee)}
                        value={ticketOwner.info?.["Referral Code"] ?? ""}
                        onChange={({ target: { value } }) =>
                          handleAnsweringQuestions({
                            question: "Referral Code",
                            required: false,
                            answer: value,
                            index,
                          })
                        }
                      />
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          ))}
      </form>
    </div>
  );
}
